import { Dto, DtoWithId } from "@mango/core";
import { Btw } from "./btw";
import { FactuurType } from './factuur-type';
import { PostType } from "./post-type";
import { Taal } from "./taal";

@Dto({fullName: "CIJBorculo.Logic.Relatie"})
export class Relatie extends DtoWithId {
	oldID: number;
	exactNr: number;
	code: string;
	naam1: string;
	naam2: string;
	tel1: string;
	tel2: string;
	fax: string;
	eMail: string;
	www: string;
	bankNaam: string;
	bankPlaats: string;
	bankRekNr: string;
	bankIban: string;
	bankBic: string;
	btwnr: string;
	kvKNr: string;
	btwId: Btw;
	taal: Taal;
	krediettermijn: number;
	kredietlimiet: number;
	aanmanen: boolean;
	isRelatie: boolean;
	isLeverancier: boolean;
	isProspect: boolean;
	bCat4: boolean;
	bCat5: boolean;
	bCat6: boolean;
	opmAlg: string;
	opmAdd: string;
	factuurtypeID: FactuurType;
	bOproep: boolean;
	bKorting: boolean;
	bCertMail: boolean;
	infoVerzend: PostType;
	infoOrder: string;
	infoShuttle: string;
	bPdfcertificaat: boolean;
	factuurKop: string;
	eMailOproep: string;
	periode: number;
	eMailFac: string;
	postPlaats: string;
	verzendPlaats: string;
	betaalTermijn: number;
	ubl: boolean;
	proFormaTerGoedkeuring: boolean;
	proFormaVoorInkoop: boolean;
	lastExportCentix: Date;
	lastExportCentixDoor: string;
	centixId: number;
	centix:boolean;
	reasonNotExported: string;
	hasProjects: boolean;
	hasInstruments: boolean;
	buitenSpecsAfkeuren: boolean;
}
